import CopyToClipboard from '@src/components/CopyToClipboard'
import UpArrowCorner from '@src/components/icons/UpArrowCorner'
import { getBlockExplorerUrlFromChainId } from '@src/utils/getBlockExplorerUrl'
import { truncateAddress } from '@src/utils/truncateAddress'

export interface SourceTxComponentProps {
    sourceTxHash?: string
    chainId?: string | number
}

export const SourceTxComponent: React.FC<SourceTxComponentProps> = ({ sourceTxHash, chainId }) => {
    // Extract the transaction hash from the full URL if it's a URL
    const txHashOnly = sourceTxHash?.includes('/')
        ? sourceTxHash.substring(sourceTxHash.lastIndexOf('/') + 1)
        : sourceTxHash

    const formattedSourceTxHash = txHashOnly && truncateAddress(txHashOnly)

    // Generate the block explorer URL if we have a chainId
    const blockExplorerUrl =
        chainId && txHashOnly ? `${getBlockExplorerUrlFromChainId(chainId)}/${txHashOnly}` : sourceTxHash // Fallback to the original URL if we don't have chainId

    return (
        <div className='flex items-center justify-between'>
            <span className='text-sm text-mach-sub-text'>Source Id</span>
            <div className='flex items-center gap-[6px]'>
                <CopyToClipboard anchorId='source-tx-hash' textToCopy={txHashOnly || ''} />
                <span className='text-sm'>{formattedSourceTxHash}</span>
                <a
                    className='flex cursor-pointer text-mach-sub-text'
                    href={blockExplorerUrl}
                    target='_blank'
                    rel='noreferrer'
                >
                    <UpArrowCorner className='h-3 w-3' />
                </a>
            </div>
        </div>
    )
}
